import { ImageWidgetMapper } from 'mapper/ImageWidgetMapper';
import { PageItemMapper } from 'mapper/PageItemMapper';
import { QuestionCheckboxMapper } from 'mapper/QuestionCheckboxMapper';
import { QuestionCommentBoxMapper } from 'mapper/QuestionCommentBoxMapper';
import { QuestionConsentMapper } from 'mapper/QuestionConsentMapper';
import { QuestionCASMapper } from 'mapper/QuestionCASMapper';
import { QuestionDemographicMapper } from 'mapper/QuestionDemographicMapper';
import { QuestionFormMapper } from 'mapper/QuestionFormMapper';
import { QuestionOpinionMapper } from 'mapper/QuestionOpinionMapper';
import { QuestionRadioMapper } from 'mapper/QuestionRadioMapper';
import { TextWidgetMapper } from 'mapper/TextWidgetMapper';

export const pageItemMapper = new PageItemMapper([
  new QuestionDemographicMapper(),
  new QuestionOpinionMapper(),
  new QuestionCommentBoxMapper(),
  new QuestionFormMapper(),
  new QuestionCheckboxMapper(),
  new QuestionConsentMapper(),
  new QuestionRadioMapper(),
  new QuestionCASMapper(),
  new QuestionDemographicMapper(),
  new TextWidgetMapper(),
  new ImageWidgetMapper(),
]);
